/*
 ######     #######   ##    ##   ########
##    ##   ##     ##  ###   ##   ##
##         ##     ##  ####  ##   ##
##         ##     ##  ## ## ##   ######
##         ##     ##  ##  ####   ##
##    ##   ##     ##  ##   ###   ##
 ######     #######   ##    ##   ##
*/

/**
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/**
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
**/
// pageAjax = true;

/**
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
// parallaxBreakpoint = 768;
desktopBreakpoint = 1024;


// Smooth Scroll Velocity
smoothScrollVelocity = 0.075;

(function($) {

	isTouch = Modernizr.touchevents;

	/*
	##     ##  ########   ####   ######    ##     ##  ########
	##     ##  ##          ##   ##    ##   ##     ##     ##
	##     ##  ##          ##   ##         ##     ##     ##
	#########  ######      ##   ##   ####  #########     ##
	##     ##  ##          ##   ##    ##   ##     ##     ##
	##     ##  ##          ##   ##    ##   ##     ##     ##
	##     ##  ########   ####   ######    ##     ##     ##
	*/

	// var adjustHeight = function() {
	// 	$('.row--set-height').each( function( index ) {
	// 		var blockHeight = $(this).innerHeight();

	// 		var innerColHeight = 0;

	// 		$(this).find('div[class^="col-"]').each( function() {
	// 			if ( $(this).innerHeight() > innerColHeight ) {
	// 				innerColHeight = $(this).innerHeight();
	// 			}
	// 		} );

	// 		// if ( innerColHeight > blockHeight ) {
	// 		// 	$(this).height( innerColHeight );
	// 		// } else {
	// 		// 	$(this).height( blockHeight );
	// 		// }

	// 		$(this).height( innerColHeight );

	// 		innerColHeight = 0;

	// 	});
	// };

	/*
	########   ########    ######    ####  ########   ########
	##     ##  ##         ##    ##    ##        ##    ##
	##     ##  ##         ##          ##       ##     ##
	########   ######      ######     ##      ##      ######
	##   ##    ##               ##    ##     ##       ##
	##    ##   ##         ##    ##    ##    ##        ##
	##     ##  ########    ######    ####  ########   ########

	##     ##     ###     ##    ##   ########   ##         ########   ########
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##
	*/

	// var footerHeight = function() {
	// 	var _footerHeight = $( '.footer-main' ).outerHeight();
	// 	console.log('footer : ' + _footerHeight );
	// 	$( '.main-content' ).css( 'padding-bottom', _footerHeight );
	// 	$(window).trigger('resize');
	// };

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		navMobileReset();
		SmoothScrollInit();
		/* Autres fonctions jouées au resize */

		// resizeSlider();
		// resizeNav();
	};


	/*
	 ######     ######    ########    #######   ##         ##
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##
	##         ##         ##     ##  ##     ##  ##         ##
	 ######    ##         ########   ##     ##  ##         ##
		  ##   ##         ##   ##    ##     ##  ##         ##
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##
	 ######     ######    ##     ##   #######   ########   ########
	*/

	// Smmoth Scroll
	var SmoothScrollInit = function() {
		if (!isTouch) {
			var scroller = new SmoothScroll({
				target: document.querySelector("#scroll-container"), // element container to scroll
				scrollEase: smoothScrollVelocity,
				maxOffset: 500
			});
		}
	};

	/* Fonctions exécutées au scroll */
	var lastScrollTop = 0;
	var scrollHandlerDebounced = function() {
		var st = $(this).scrollTop();

		if (st > lastScrollTop || st < $(window).height() * 0.5 ) {
			$('html').removeClass('is--scroll-up');
		} else {
			$('html').addClass('is--scroll-up');
		}
		lastScrollTop = st;

	};


	var scrollHandler = function() {
		var scrolled = $(window).scrollTop();

		// /* EXEMPLE */
		if (scrolled > ( $(window).height() * 0.5 ) ) {
			$('html').addClass('is--scroll');
		}
		else {
			$('html').removeClass('is--scroll');
		}

		if (scrolled > ( $(window).height() * 1.5 ) ) {
			$('html').addClass('is--banner-hidden');
		}
		else {
			$('html').removeClass('is--banner-hidden');
		}

		// Home
		if ( $('body').data('template') == "template-home" && !isTouch ) {
			TweenLite.set( '.banner__animation', { y: 0 + ( scrolled * 0.2 ), rotation: 0.01, delay: 0.1, force3D: true } );
			TweenLite.set( '.banner__title', { scale: 1 - ( scrolled * 0.00035 ), opacity: 1 - ( scrolled * 0.001 ), rotation: 0.01, force3D: true } );
		}

		if ( $('body').data('template') == "template-home" && isTouch ) {
			TweenLite.set( '.banner__animation', { top: 0 - ( scrolled * 0.8 ) } );
			TweenLite.set( '.banner__title', { scale: 1 - ( scrolled * 0.00035 ), opacity: 1 - ( scrolled * 0.002 ) } );

		}


	};

	/*
	 ######    ##     ##  ########    ######     #######   ########
	##    ##   ##     ##  ##     ##  ##    ##   ##     ##  ##     ##
	##         ##     ##  ##     ##  ##         ##     ##  ##     ##
	##         ##     ##  ########    ######    ##     ##  ########
	##         ##     ##  ##   ##          ##   ##     ##  ##   ##
	##    ##   ##     ##  ##    ##   ##    ##   ##     ##  ##    ##
	 ######     #######   ##     ##   ######     #######   ##     ##
	*/


	function moveCircle( e ) {
		TweenLite.to( $('.mouse-cursor'), 0.3, { left: e.pageX, top: e.pageY, delay: 0.001 } );
	}

	if ( ! isTouch ) {
		$( window ).on( 'mousemove', moveCircle );
		$('a, [data-link], .dive-site__pointer, .video-control svg, .video-mute').on('mouseenter', function() {
			$('body').addClass('pointer-hover');

			// elementX = $(this).offset().left + ( $(this).outerWidth() / 2 );
			// elementY = $(this).offset().top  + ( $(this).outerHeight() / 2 );

			// TweenLite.to( $('.mouse-cursor'), 0.3, { left: elementX, top: elementY, scale: 1, autoAlpha: 0.4 } );
			 TweenLite.to( $('.mouse-cursor'), 0.3, { scale: 0.8, autoAlpha: 0.1 } );


		});

		$('a, [data-link], .dive-site__pointer, .video-control svg, .video-mute').on('mouseleave', function(e) {
			$('body').removeClass('pointer-hover');
			TweenLite.to( $('.mouse-cursor'), 0.2, { scale: 0.2, autoAlpha: 0.1 } );
		});
	}

	/*
	   ###     ##    ##   ####  ##     ##   ######
	  ## ##    ###   ##    ##   ###   ###  ##    ##
	 ##   ##   ####  ##    ##   #### ####  ##
	##     ##  ## ## ##    ##   ## ### ##   ######
	#########  ##  ####    ##   ##     ##        ##
	##     ##  ##   ###    ##   ##     ##  ##    ##
	##     ##  ##    ##   ####  ##     ##   ######
	*/



	function parallaxIt(e, target, movement, x, y, delay) {

		var $this = target.closest('.mouse-animated');
		var relX  = e.pageX - $this.offset().left;
		var relY  = e.pageY - $this.offset().top;
		delay     = delay || 0;

		TweenMax.to(target, 2, {
			x: ( relX - $this.width() / x ) / $this.width() * movement,
			y: ( relY - $this.height() / y ) / $this.height() * movement,
			rotation: 0.01,
			delay: delay,
			force3D: false
		});
	}

	if ( $( '.banner--home' ).length > 0 ) {
		$( '.banner--home' ).mousemove( function( e ) {
			parallaxIt( e, $(this).find('.anim.cloud-1'), 2, 1, 2, 0.1 );
			parallaxIt( e, $(this).find('.anim.cloud-2'), -5, 1, 2 );
			parallaxIt( e, $(this).find('.anim.cloud-3'), 5, 1, 2, 0.2 );
		});
	}

	if ( $( '.banner--default' ).length > 0 ) {
		$( '.banner--default' ).mousemove( function( e ) {
			if ( $( '.banner__picto' ).length > 0 ) {
				parallaxIt( e, $(this).find('.banner__picto'), -10, 2, 2, 1 );
			}
			parallaxIt( e, $(this).find('.main'), -20, 2, 2, 1 );
			parallaxIt( e, $(this).find('.main--underline'), 20, 2, 2, 1 );
		});
	}

	if ( ! isTouch ) {
		if ( $( '.video-container' ).length > 0 ) {
			$( '.video-container' ).mousemove( function( e ) {
				parallaxIt( e, $(this).find('.video__fish-top'), 15, 1, 1, 0.1 );
				parallaxIt( e, $(this).find('.video'), 15, 1, 1 );
				parallaxIt( e, $(this).find('.video-control svg'), 15, 1, 1, 0.1 );
				parallaxIt( e, $(this).find('.video__fish-bottom'), 20, 1, 1, 0.2 );
			});
		}

		if ( $( '.block-shortcut__item' ).length > 0 ) {
			$( '.block-shortcut__item' ).mousemove( function( e ) {
				parallaxIt( e, $(this).find('figure'), 8, 1, 1 );
				parallaxIt( e, $(this).find('.block-shortcut__meta'), 20, 1, 1 );
				parallaxIt( e, $(this).find('svg'), 6, 1, 1, 0.1 );
			});
		}

		if ( $( '.meettheteam' ).length > 0 ) {
			$( '.meettheteam' ).mousemove( function( e ) {
				parallaxIt( e, $(this).find('.turtle-top'), -10, 1, 1);
				parallaxIt( e, $(this).find('.turtle-bottom'), -10, 1, 1 );
				parallaxIt( e, $(this).find('.meettheteam__picture'), 10, 1, 1);
			});
		}

		if ( $( '.arguments' ).length > 0 ) {
			$( '.arguments' ).mousemove( function( e ) {
				parallaxIt( e, $(this).find('.arguments__count'), 10, 1, 1);
			});
		}

		if ( $( '.reviews__item' ).length > 0 ) {
			$( '.reviews__item' ).mousemove( function ( e ) {
				parallaxIt( e, $(this).find('.figure'), 10, 1, 1);
				if ( $(this).find('.figure').length > 0 ) {
					parallaxIt( e, $(this).find('.plus'), -5, 1, 1);
				}
				parallaxIt( e, $(this).find('.reviews__title'), -12, 1, 1);
				parallaxIt( e, $(this).find('.reviews__guestname'), 5, 1, 1);
			});
		}

		if ( $( '.footer-main' ).length > 0 ) {
			$( '.footer-main' ).mousemove( function( e ) {
				parallaxIt( e, $(this).find('.anemone-top'), 30, 1, 1);
				parallaxIt( e, $(this).find('.anemone-bottom'), 30, 1, 1 );
				parallaxIt( e, $(this).find('.fish-top'), -20, 1, 1);
				parallaxIt( e, $(this).find('.fish-bottom'), -20, 1, 1 );
			});
		}

		if ( $( '.mouse-animated' ).length > 0 ) {
			$( '.mouse-animated' ).each( function() {
				$(this).mousemove( function( e ) {
					if ( $(this).find( '.mouse-1' ).length > 0 ) {
						parallaxIt( e, $(this).find( '.mouse-1' ), -10, 1, 1  );
					}
					if ( $(this).find( '.mouse-2' ).length > 0 ) {
						parallaxIt( e, $(this).find( '.mouse-2' ), 10, 1, 1  );
					}
					if ( $(this).find( '.mouse-3' ).length > 0 ) {
						parallaxIt( e, $(this).find( '.mouse-3' ), -5, 1, 1, 0.1  );
					}
					if ( $(this).find( '.mouse-4' ).length > 0 ) {
						parallaxIt( e, $(this).find( '.mouse-4' ), 5, 1, 1, 0.1  );
					}
				});
			} );
		}


	}

	/*
	##     ##  ####  ########   ########    #######
	##     ##   ##   ##     ##  ##         ##     ##
	##     ##   ##   ##     ##  ##         ##     ##
	##     ##   ##   ##     ##  ######     ##     ##
	 ##   ##    ##   ##     ##  ##         ##     ##
	  ## ##     ##   ##     ##  ##         ##     ##
	   ###     ####  ########   ########    #######
	*/
	if ( isTouch ) {
		$('.video-html5').find('video').trigger('pause');
		$('.video-control').addClass('paused');
	}

	$('.video-control').on('click', function() {
		$video = $(this).closest('.video-html5').find('video');

		if ( $(this).hasClass('paused') ) {
			$video.trigger('play');
			$(this).removeClass('paused');
		} else {
			$video.trigger('pause');
			$(this).addClass('paused');
		}
	});

	$('.video-mute').on('click', function() {

		$video = $(this).closest('.video-html5').find('video');

		if ( $video.prop('muted') ) {
			$video.prop('muted', false);
			$(this).addClass('unmuted');
		} else {
			$video.prop('muted', true);
			$(this).removeClass('unmuted');
		}
	});


	/*
	 ######    ##         ####  ########   ########   ########    ######
	##    ##   ##          ##   ##     ##  ##         ##     ##  ##    ##
	##         ##          ##   ##     ##  ##         ##     ##  ##
	 ######    ##          ##   ##     ##  ######     ########    ######
	      ##   ##          ##   ##     ##  ##         ##   ##          ##
	##    ##   ##          ##   ##     ##  ##         ##    ##   ##    ##
	 ######    ########   ####  ########   ########   ##     ##   ######
	*/
	var slidersInit = function() {
		// MODULE SLIDER
		var $mod_slider = $('.block-slider');

		$mod_slider.each( function() {

			var $text           = $(this).find('.slider__text');
			var $text_2         = $(this).find('.slider__text_2');
			var $images         = $(this).find('.slider__image');
			var $autoplay       = false;
			var $adaptiveHeight = false;
			var $dive_sites     = false;

			if ( $text.hasClass('slider__dive-sites') ) {
				$adaptiveHeight = true;
				$dive_sites     = true;
			}

			if ( $text.length ) {
				$autoplay = $text.data('autoplay');
			}

			// If images slider is active, we define relation from text slider to images slider
			if ( $images.length ) {
				$asNavFor = $images;
			} else {
				$asNavFor = false;
			}

			if ( $text_2.length ) {
				$slider = $text_2;
			}

			if ( $text.length ) {
				$text.on( 'init', function( slick ) {
					$(window).trigger('resize');
				});

				$text.slick({
					autoplay: $autoplay,
					autoplaySpeed: 5000,
					slidesToShow: 1,
					margin: 20,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: false,
					fade: true,
					speed: 500,
					easing: 'swing',
					asNavFor: $asNavFor,
					adaptiveHeight: $adaptiveHeight
				});
			}

			if ( $text_2.length ) {
				$text_2.on( 'init', function( slick ) {
					$(window).trigger('resize');
				});

				$text_2.slick({
					autoplay: $autoplay,
					autoplaySpeed: 5000,
					slidesToShow: 1,
					margin: 20,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: false,
					fade: true,
					speed: 500,
					easing: 'swing',
					asNavFor: $text,
					adaptiveHeight: false
				});
			}

			if ( $images.length ) {
				$images.on( 'init', function( slick ) {
					$(window).trigger('resize');
				});

				$images.imagesLoaded( function() {
					$images.slick({
						autoplay: false,
						autoplaySpeed: 5000,
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: false,
						fade: false,
						speed: 600,
						easing: 'easeInOutElastic',
						asNavFor: $text,
						adaptiveHeight: false
					});
				});
			}

			// Arrow navigation
			$(this).find( '.next' ).on( 'click', function(e) {
				e.preventDefault();
				$text.slick( 'slickNext' );
			});

			$(this).find( '.prev' ).on( 'click', function(e) {
				e.preventDefault();
				$text.slick( 'slickPrev' );
			});

			// Counter
			if ( $(this).find( '.counter' ).length > 0 ) {
				var $slideCurrent = $(this).find('.counter__current');
				var $slideTotal   = $(this).find('.counter__total');
				$slideCurrent.text(1);
				$slideTotal.text($(this).find('.block__slide').length);

				$text.on( 'afterChange', function ( event, slick, currentSlide, nextSlide ) {
					//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
					var i = ( currentSlide ? currentSlide : 0 ) + 1;
					$slideCurrent.text( i );
					$slideTotal.text( slick.slideCount );
				});
			}

			// Autoheight for dive sites slider
			if ( $adaptiveHeight == true ) {
				$text.on( 'afterChange', function ( event, slick, currentSlide, nextSlide ) {
					$(window).trigger('resize');
				});
			}

			// Dive sites nav
			if ( $dive_sites === true ) {
				$('.dive-site__pointer').on( 'click', function() {
					var index = $(this).data('index');
					$(this).closest('.block-slider--dive-sites').find('.slider__dive-sites').slick('slickGoTo', index );
				});

				$('.slider__dive-sites').on( 'afterChange', function ( event, slick, currentSlide, nextSlide ) {
					var index = currentSlide;
					$('.dive-site__pointer').removeClass('current');
					$('.dive-site__pointer').each( function() {
						if ( $(this).data('index') == index ) {
							$(this).addClass('current');
						}
					});
				});
			}
		});
	};

	/*
	##          #######      ###     ########   ########   ########
	##         ##     ##    ## ##    ##     ##  ##         ##     ##
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##
	##         ##     ##  ##     ##  ##     ##  ######     ########
	##         ##     ##  #########  ##     ##  ##         ##   ##
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##
	########    #######   ##     ##  ########   ########   ##     ##
	*/

	showLoader = function(url) {
		var $loader = $('.loader');

		tl = new TimelineLite();
		tl.pause();
		tl.add([
			TweenMax.fromTo( $loader,  0.4, { opacity: '1', y: '100%' }, { opacity: '1', y:'0', delay: 0 } )
		]);
		tl.call(function() {
			$(window).scrollTop(0);
			if( !pageAjax ){
				// A la fin de l'anim, on redirige vers la nouvelle URLs
				window.location.href = url;
			}else{
				// mise à jour de la variable qui indique que l'animation est terminée
				showLoaderProgressing  = false;
			}
		});
		tl.play();
	};

	var hideLoader = function() {
		var $loader = $('.loader');

		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.call(function() {
			initScrollAnimations();
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			TweenMax.fromTo( $loader,  0.4, { opacity: '1', y:'0' }, { opacity: '0', y: '100%', delay: 0 } )
		], [], this, 1);
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page
		Uniquement si la fonction de transition de page est active
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	##    ##      ###     ##     ##
	###   ##     ## ##    ##     ##
	####  ##    ##   ##   ##     ##
	## ## ##   ##     ##  ##     ##
	##  ####   #########   ##   ##
	##   ###   ##     ##    ## ##
	##    ##   ##     ##     ###
	*/

	var $nav      = $('.nav-main');
	var $nav_item = $('.nav-main--lev1 .menu-item--lev1');

	showNav = function(url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			TweenMax.to( $nav, 0, { x: '0%' } ),
			TweenMax.fromTo( $nav, 0.3,   { opacity: 0 }, { opacity: 1, delay: 0 } ),
			TweenMax.staggerFromTo( $nav_item, 0.60, { opacity: 0, y: 40 }, { opacity: 1, y: 0, ease: CustomEase.create("custom", "M0,0,C0.428,0.032,0.437,1.121,0.554,1.044,0.838,0.854,0.818,1,1,1") }, 0.05 )
		]);
		tl.play();
	};

	var hideNav = function() {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			TweenMax.staggerFromTo( $nav_item, 0.20, { opacity: 1, y: 0 }, { opacity: 0, y: 40 }, -0.04 ),
			TweenMax.fromTo( $nav, 0.3, { opacity: 1 }, { opacity: 0, delay: 0.40 } ),
			TweenMax.to( $nav, 0,   { x: '101%', delay: 0.65 } )

		]);
		tl.play();
	};

	var resetNavDirect = function() {
		$nav.removeAttr("style");
		$nav_item.removeAttr("style");
	};

	navMobileReset = function() {
		if ( jQuery(window).width() >= desktopBreakpoint ) {
			$('html').removeClass('is--nav-open');
			resetNavDirect();
		}
	};

	$('.toggle__nav-main').on('click', function() {

		if ( $('html').hasClass('is--nav-open') ) {
			$('html').removeClass('is--nav-open');
			hideNav();

		} else {
			$('html').addClass('is--nav-open');
			showNav();

		}
	});

	$('.reviews__item .plus').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		showCloseBtn: false,
		preloader: false,

		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});

	$(document).on('click', '#scrolltocontent', function(event) {
		event.preventDefault();
		var viewportHeight = $(window).height() * 0.9;

		$('html, body').animate({
			scrollTop: viewportHeight

		}, 700, function() {
			$('#scrolltocontent').addClass('btn--hidden');
		});
	});

	/*
	####  ##    ##   ####  ########
	 ##   ###   ##    ##      ##
	 ##   ####  ##    ##      ##
	 ##   ## ## ##    ##      ##
	 ##   ##  ####    ##      ##
	 ##   ##   ###    ##      ##
	####  ##    ##   ####     ##
	*/

	// Charge la function permettant de gérer le chargement des pages via AJAX
	if( pageAjax ){
		ajaxUrl.init();
	}

	var pageInit = function() {

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler );
		$(window).on('scroll', debounce( 20, false, scrollHandlerDebounced));
		$('body').on('reveal', '.sr', scrollRevealHandler);

		formLoader();                // Affiche un 'cache' à la validation d’un form CF7
		slidersInit();
		$(window).trigger('resize'); // Joue la fonction resizeHandler()

		/* Autres scripts qui doivent être initialisés */
		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').click(function(e) {
			linkHandler( $(this) );
		}).find('a').click(function(e) {
			e.stopPropagation();
		});

		$('a').click(function(e) {
			e.preventDefault();
			linkHandler( $(this) );
		});

		// Charge la function permettant de gérer le chargement des pages via AJAX
		if( pageAjax ){
			ajaxUrl();
		}
	};

	// Functions à réinitialisées après un chargement de page via ajax
	afterAjax = function(){

		$('.data-mh').matchHeight();
		resizeParallax();

	};

	// 
	$( ".btn--in-editor" ).wrapInner( "<span></span>");

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

	// Mcube Gmaps (page contact)
	$('.google-map').mcubeGmaps({
		bounds:  false, // default : true
		overlay: false, // default : true
		styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#3e606f"},{"weight":2},{"gamma":0.84}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"weight":0.6},{"color":"#1a3541"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#2c5a71"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#406d80"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#2c5a71"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#29768a"},{"lightness":-37}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#406d80"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#193341"}]}]
	});

})(jQuery);